import React from 'react';
import Chip from '@mui/material/Chip';

import { withStyles } from '@mui/styles';

const styles = {
  chip: {
    fontSize: '11px',
    height: '27px',
  },
  chipSpan: {
    padding: '0 8px',
  },
};

export default withStyles(styles)(({ text, classes }) => {
  return <Chip size="small" label={text} className={classes.chip} classes={{ label: classes.chipSpan }} />;
});
